import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {MasbitHttpService} from '../../../common/http/masbit-http.service';

@Injectable()
export class ChangePasswordService {
  private static readonly VALIDATE_CHANGE_PASSWORD_URL = environment.apiUrl.concat(environment.validateChangePassword);
  private static readonly CHANGE_PASSWORD_URL = environment.apiUrl.concat(environment.changePassword);

  constructor(private httpClient: MasbitHttpService) { }

  validateChangePassword(token: string) {
    let params = {token: token};
    return this.httpClient.get<{status: number, message: string}>(ChangePasswordService.VALIDATE_CHANGE_PASSWORD_URL,
                                                                  new HttpParams().set('token', token));
  }

  changePassword(password: string, token: string) {
    let params = {token: token, password: password};
    return this.httpClient.get<{status: number, message: string}>(ChangePasswordService.CHANGE_PASSWORD_URL,
                                                                  new HttpParams().set('token', token).set('password', password) );
  }

}
